import { DOC_FLOW_PRE_FILTER } from '../../constants/docFlow'
import { EMAIL_PRE_FILTER } from '../../constants/email'
import {
  ASSIGNEE_FILTER_NAME,
  BUILDING_FILTER_NAME,
} from '../../constants/filter'
import { REQUEST_PRE_FILTER } from '../../constants/request'
import {
  EMAIL_FOLDER_DEFAULT_VALUE,
  FILTER_PARAM_KEY,
  FILTER_SCOPE_PARAM_ASSIGNED_VALUE,
  ROUTE_PATH_LIST,
  ROUTE_UI_SECTION_NAME,
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ACTIVE_VALUE,
  SUBMENU_PARAM_KEY,
} from '../../constants/route'
import { TASK_PRE_FILTER } from '../Task'

import { BirdviewTileKey } from './DashboardBirdview.constants'
import { BirdviewChartObject } from './DashboardBirdview.constants.charts'

const REQUESTS_PATH = `/${ROUTE_PATH_LIST.serviceRequests}`

const INHABITANTS_PATH = `/${ROUTE_PATH_LIST.inhabitants}`

const MAILS_PATH = `/${ROUTE_PATH_LIST.mails}`

const DOC_FLOWS_PATH = `/${ROUTE_PATH_LIST.docFlows}`

const ACTIVITIES_PATH = `/${ROUTE_PATH_LIST.tasks}`

const CHATS_PATH = `/${ROUTE_PATH_LIST.chats}`

const DWELLER_DOCUMENTS_PATH = `/${ROUTE_PATH_LIST.documentsDweller}`

const FLATS_PATH = `/${ROUTE_PATH_LIST.flats}`

const NEWSBOARD_PATH = `/${ROUTE_PATH_LIST.newsboard}`

// These lists ignore the work scope, so their pre-filter is part of the path.
const UNREAD_MAILS_PATH = `${MAILS_PATH}?${FILTER_PARAM_KEY}=${EMAIL_PRE_FILTER.unread}&${SUBMENU_PARAM_KEY}=${EMAIL_FOLDER_DEFAULT_VALUE}`

const OPEN_DOC_FLOWS_PATH = `${DOC_FLOWS_PATH}?${FILTER_PARAM_KEY}=${DOC_FLOW_PRE_FILTER.open}&${SUBMENU_PARAM_KEY}=${SUBMENU_PARAM_ACTIVE_VALUE}`

// A list target names its ui section, so a card can send the user to the old
// webapp while the NG app does not serve that list yet.
const REQUESTS_TARGET = {
  path: REQUESTS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.serviceRequests,
  sub: SUBMENU_PARAM_ACTIVE_VALUE,
}

const INHABITANTS_TARGET = {
  path: INHABITANTS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.inhabitants,
}

const UNREAD_MAILS_TARGET = {
  path: UNREAD_MAILS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.mails,
}

const ACTIVITIES_TARGET = {
  path: ACTIVITIES_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.activities,
  sub: SUBMENU_DEFAULT_VALUE,
}

const OPEN_DOC_FLOWS_TARGET = {
  path: OPEN_DOC_FLOWS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.docFlows,
}

const CHATS_TARGET = {
  path: CHATS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.chats,
}

const DWELLER_DOCUMENTS_TARGET = {
  path: DWELLER_DOCUMENTS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.documentsDweller,
}

const FLATS_TARGET = {
  path: FLATS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.flats,
}

const NEWSBOARD_TARGET = {
  path: NEWSBOARD_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.newsboard,
  webappPath: '/',
}

// No list filter matches an attention group, so Show all opens the backlog.
const BACKLOG_REQUESTS_TARGET = {
  ...REQUESTS_TARGET,
  preFilter: REQUEST_PRE_FILTER.backlog,
}

export const BIRDVIEW_TILE_TARGET = {
  [BirdviewTileKey.Backlog]: BACKLOG_REQUESTS_TARGET,
  [BirdviewTileKey.Input]: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.needsInput,
  },
  [BirdviewTileKey.NoProvider]: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.withoutProvider,
  },
  [BirdviewTileKey.Overdue]: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.overdue,
  },
  [BirdviewTileKey.Unassigned]: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.unassigned,
  },
  [BirdviewTileKey.Unread]: UNREAD_MAILS_TARGET,
}

export const BIRDVIEW_SECTION_TARGET = {
  activities: { ...ACTIVITIES_TARGET, preFilter: TASK_PRE_FILTER.due },
  attention: BACKLOG_REQUESTS_TARGET,
  communication: UNREAD_MAILS_TARGET,
  criticalRequests: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.critical,
    scopeValue: FILTER_SCOPE_PARAM_ASSIGNED_VALUE,
  },
  docFlows: OPEN_DOC_FLOWS_TARGET,
  dwellerAnnouncements: NEWSBOARD_TARGET,
  dwellerDocuments: DWELLER_DOCUMENTS_TARGET,
  dwellerMessages: CHATS_TARGET,
  dwellerObjects: FLATS_TARGET,
  properties: BACKLOG_REQUESTS_TARGET,
  requests: REQUESTS_TARGET,
  serviceRequests: {
    ...REQUESTS_TARGET,
    preFilter: REQUEST_PRE_FILTER.mine,
  },
  teamLoad: BACKLOG_REQUESTS_TARGET,
}

export const BIRDVIEW_CHART_OBJECT_TARGET = {
  [BirdviewChartObject.Customers]: INHABITANTS_TARGET,
  [BirdviewChartObject.Requests]: REQUESTS_TARGET,
}

export const BIRDVIEW_ROW_TARGET = {
  properties: {
    ...BACKLOG_REQUESTS_TARGET,
    rowFilterName: BUILDING_FILTER_NAME,
  },
  teamLoad: { ...BACKLOG_REQUESTS_TARGET, rowFilterName: ASSIGNEE_FILTER_NAME },
}
